objUnwrapped